(() => {
  if (window.__fsEnhancements) return;
  window.__fsEnhancements = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dataSaver = navigator.connection?.saveData === true;
  if (reducedMotion.matches || dataSaver) {
    document.documentElement.classList.add('fs-motion-reduced');
    return;
  }

  const root = document.documentElement;
  const prepared = new WeakSet();
  const headingSelector = [
    '.fs-parity-media__heading',
    '.fs-home-feature__heading',
    '.fs-home-story__heading',
    '.fs-home-outcomes__heading',
    '.fs-home-proof__heading',
    '.fs-route__title',
    '.fs-route__heading',
    '.fs-support__heading',
    '.fs-story__heading',
    '.fs-product__title',
  ].join(',');

  root.classList.add('fs-enhanced-motion');

  const reveal = (section) => {
    section.classList.add('fs-motion-visible');
    observer.unobserve(section);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    },
    { rootMargin: '0px 0px -8%', threshold: 0.08 },
  );

  const prepareSection = (section) => {
    if (prepared.has(section)) return;
    prepared.add(section);
    const isInitiallyVisible = section.getBoundingClientRect().top <= window.innerHeight * 0.9;
    section.classList.add('fs-motion-ready');
    section.querySelectorAll(headingSelector).forEach((heading) => heading.classList.add('fs-kinetic-heading'));

    if (isInitiallyVisible) reveal(section);
    else observer.observe(section);
  };

  const prepare = (scope = document) => {
    const sections = scope.matches?.('main > .shopify-section')
      ? [scope]
      : [...scope.querySelectorAll('main > .shopify-section')];
    sections.forEach(prepareSection);
  };

  const progress = document.createElement('div');
  progress.className = 'fs-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.prepend(progress);

  let progressFrame = 0;
  const updateProgress = () => {
    progressFrame = 0;
    const range = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const value = Math.min(1, Math.max(0, window.scrollY / range));
    progress.style.setProperty('--fs-scroll-progress', value.toFixed(4));
  };
  const requestProgress = () => {
    if (progressFrame) return;
    progressFrame = requestAnimationFrame(updateProgress);
  };

  window.addEventListener('scroll', requestProgress, { passive: true });
  window.addEventListener('resize', requestProgress, { passive: true });
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  document.addEventListener('shopify:section:unload', (event) => observer.unobserve(event.target));

  prepare();
  updateProgress();
})();
